import React from 'react';
import Projects from "./Projects"

const ProjectList = () =>
    <section id="projects" className="clearfix main">
        <div className="container-fluid">
            <div className="row">
                <div className="col-xs-12 col-sm-offset-1 col-sm-8 col-md-offset-3 col-md-6 col-lg-5">
                    <Projects />
                </div>
            </div>
        </div>
    </section>

export default ProjectList;
